import React, { useEffect, useState } from 'react';
import { MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { useConsult } from '../contexts/ConsultContext';
const links = [{
  label: 'Why it works',
  href: '#why'
}, {
  label: 'What to expect',
  href: '#process'
}, {
  label: 'Results',
  href: '#results'
}, {
  label: 'Questions',
  href: '#faq'
}];
export function SiteHeader() {
  const {
    openConsult
  } = useConsult();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`sticky top-0 z-40 w-full border-b transition-[background-color,border-color,box-shadow] duration-200 ease-smooth ${scrolled ? 'border-ash-200 bg-white/95 backdrop-blur shadow-sm' : 'border-transparent bg-white'}`} data-id="element-184" data-mp="2gbbr08r6370m">
      <div className="mx-auto flex h-20 w-full max-w-7xl items-center justify-between px-5 lg:px-8" data-id="element-185" data-mp="29jk4isgknv9v">
        <a href="#top" className="flex items-baseline gap-2" data-id="element-186" data-mp="2ekzt2uhykjx0">
          <span className="font-display text-2xl tracking-tight text-ash-900" data-id="element-187" data-mp="2jj1dpjv18ral">Ultherapy</span>
          <span className="rounded bg-royal-600 px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.2em] text-white" data-id="element-188" data-mp="2og1i7qc8hlzl">
            Prime
          </span>
        </a>

        <nav aria-label="Primary" className="hidden items-center gap-8 lg:flex" data-id="element-189" data-mp="1vs5o8te1u86i">
          {links.map(link => <a key={link.href} href={link.href} className="text-sm font-medium text-ash-600 transition-colors duration-150 ease-smooth hover:text-royal-700" data-id="element-190" data-mp="20qytxzn3guw4">
              {link.label}
            </a>)}
        </nav>

        <div className="hidden items-center gap-3 lg:flex" data-id="element-191" data-mp="1d1nymxoijspd">
          <a href="tel:18005550188" className="flex items-center gap-2 text-sm font-semibold text-ash-700 transition-colors duration-150 ease-smooth hover:text-royal-700" data-id="element-192" data-mp="1d034h9642bs1">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-193" data-mp="1002dojf53usa" />
            (800) 555-0188
          </a>
          <Button onClick={() => openConsult('header')} data-id="element-194" data-mp="1et43boz5h24g">Book a free consult</Button>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} className="rounded-lg p-2 text-ash-700 transition-colors duration-150 ease-smooth hover:bg-ash-100 lg:hidden" data-id="element-195" data-mp="19u19l0omeibs">
          {open ? <XIcon className="h-6 w-6" data-id="element-196" data-mp="vy746rn22b3f" /> : <MenuIcon className="h-6 w-6" data-id="element-197" data-mp="r176b40d0ene" />}
        </button>
      </div>

      {open && <div className="border-t border-ash-200 bg-white px-5 py-4 lg:hidden" data-id="element-198" data-mp="27f73463wro6f">
          <nav aria-label="Mobile" className="flex flex-col gap-1" data-id="element-199" data-mp="22gm3o8whd8j1">
            {links.map(link => <a key={link.href} href={link.href} onClick={() => setOpen(false)} className="rounded-lg px-2 py-3 text-base font-medium text-ash-700 transition-colors duration-150 ease-smooth hover:bg-ash-50" data-id="element-200" data-mp="2a0eiwkhd455r">
                {link.label}
              </a>)}
          </nav>
          <Button className="mt-3 w-full" size="lg" onClick={() => {
        setOpen(false);
        openConsult('mobile-nav');
      }} data-id="element-201" data-mp="251bnlrr6pdaz">
            Book a free consult
          </Button>
        </div>}
    </header>;
}